var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    fill: "#7371FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0057 29.7044C34.4086 30.1024 33.7151 30.3128 33 30.3128C32.285 30.3128 31.5914 30.1024 30.9943 29.7044L21.1598 23.1478C21.1052 23.1114 21.0521 23.0735 21 23.0345V33.7781C21 35.0099 21.9996 35.9875 23.2094 35.9875H42.7906C44.0224 35.9875 45 34.9879 45 33.7781V23.0345C44.9478 23.0736 44.8945 23.1116 44.8398 23.148L35.0057 29.7044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9398 21.9777L31.7744 28.5343C32.1466 28.7825 32.5733 28.9066 33 28.9066C33.4267 28.9066 33.8534 28.7825 34.2256 28.5343L44.0602 21.9777C44.6487 21.5856 45 20.9294 45 20.2211C45 19.0032 44.0092 18.0125 42.7914 18.0125H23.2086C21.9908 18.0125 21 19.0033 21 20.2222C21 20.9294 21.3514 21.5856 21.9398 21.9777Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    stroke: "#7371FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.3cae4fdd7b4fc361eb54a27e1af46e38.svg";
export { ForwardRef as ReactComponent };